import _ from "lodash";

export function convertRateToEmixtier(rate) {
  const scale = {
    'AAA': v => _.inRange(v, 9.5, 10),
    'AA': v => _.inRange(v, 8.5, 9.5),
    'A': v => _.inRange(v, 7.5, 8.5),
    'BBB': v => _.inRange(v, 6.5, 7.5),
    'BB': v => _.inRange(v, 5.5, 6.5),
    'B': v => _.inRange(v, 4.5, 5.5),
    'CCC': v => _.inRange(v, 3.5, 4.5),
    'CC': v => _.inRange(v, 2.5, 3.5),
    'C': v => _.inRange(v, 1.5, 2.5),
    'SM': v => _.inRange(v, 0, 1.5),
  };

  return Object.keys(scale).reverse().find(e => scale[e](rate));
}



// WEBPACK FOOTER //
// ./src/utils/assets.js